// Define the type for each item in the dataColor array
interface DataColor {
  text: number; // Represents the text value
  color: string; // Represents the color associated with the text
}

// Define the dataColor array using the DataColor type
export const dataColor: DataColor[] = [
  { text: 1, color: '#F6E9F0' }, // Rose Quartz
  { text: 2, color: '#FFD5CF' }, // Peach Blush
  { text: 3, color: '#FFF7D6' }, // Champagne Soft Gold
  { text: 4, color: '#D2E5F9' }, // Powder Blue (Blue Luxury)
  { text: 5, color: '#E6F9D0' }, // Spring Mint (Lime)
  { text: 6, color: '#C8F3E0' }, // Soft Emerald (Light Green)
  { text: 7, color: '#D9F3F7' }, // Icy Cyan Blue
  { text: 8, color: '#E1E4E8' }, // Elegant Gray (for Neutral)
];
